import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Home from './pages/Home';
import UserProfile from './UserProfile';
import Serialylist from './components/Serialylist';
import Filmylist from './components/Filmylist';
import Player from './components/player';
import PlayPage from './pages/PlayPage';
import AdminSeriesPopupEditor from './components/AdminSeriesPopupEditor';
import AdminNotifications from './components/AdminNotifications';
import AdminUpload from './pages/AdminUpload';
import WatchlistPage from './pages/Watchlist';
import { useAuth } from './contexts/AuthContext';

const AdminOnly = ({ component: Component, ...rest }) => {
  const { role, loading } = useAuth();
  const allowed = role === 'Majitel' || role === 'Admin';
  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) return null; // or a tiny loader
        return allowed ? <Component {...props} /> : <Redirect to="/" />;
      }}
    />
  );
};

const Routes = () => {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/serialy" exact component={Serialylist} />
      <Route path="/filmy" exact component={Filmylist} />
  <Route path="/watchlist" exact component={WatchlistPage} />
  <Route path="/Watchlist" exact component={WatchlistPage} />
  <Route path="/player" exact component={Player} /> {/* legacy */}
  <Route path="/play/:id" exact component={PlayPage} />
      <Route path="/profil" exact component={UserProfile} />
  <AdminOnly path="/admin/popups" exact component={AdminSeriesPopupEditor} />
  <AdminOnly path="/admin/notifikace" exact component={AdminNotifications} />
  <AdminOnly path="/admin/upload" exact component={AdminUpload} />
    </Switch>
  );
};

export default Routes;